class LoginResultModel {
    constructor({ success = false, id = '', token = "", message = "" } = {}) {
        this._success = success;
        this._id = id;
        this._token = token;
        this._message = message;
    }

    // ✅ Getter and Setter for success
    get success() {
        return this._success;
    }

    set success(value) {
        if (typeof value !== "boolean") {
            throw new Error("Success must be a boolean");
        }
        this._success = value;
    }

    // ✅ Getter and Setter for id
    get id() {
        return this._id;
    }

    set id(value) {
        if (typeof value !== "string") {
            throw new Error("ID must be a string");
        }
        this._id = value;
    }

    // ✅ Getter and Setter for token
    get token() {
        return this._token;
    }

    set token(value) {
        if (typeof value !== "string") {
            throw new Error("Token must be a string");
        }
        this._token = value;
    }

    // ✅ Getter and Setter for message
    get message() {
        return this._message;
    }

    set message(value) {
        if (typeof value !== "string") {
            throw new Error("Message must be a string");
        }
        this._message = value;
    }

    // ✅ Convert instance to a plain object
    toJSON() {
        return {
            success: this._success,
            id: this._id,
            token: this._token,
            message: this._message
        };
    }
}

export default LoginResultModel;